import { render, staticRenderFns } from "./CreateUserCompany.vue?vue&type=template&id=4094c27e&scoped=true"
import script from "./CreateUserCompany.vue?vue&type=script&lang=js"
export * from "./CreateUserCompany.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=4094c27e&prod&scoped=true&lang=css&external"
import style1 from "./CreateUserCompany.vue?vue&type=style&index=1&id=4094c27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094c27e",
  null
  
)

export default component.exports